import React from 'react';
import { BillingLanding } from '@features/billing';
import { Alert, Box, Container } from '@mui/material';
import { useFeatureGate } from '@services/statsig';

export const BillingLandingView: React.FC = () => {
  const hasBillingAccess = useFeatureGate('jotbill');

  // Check if user has access to billing feature
  if (!hasBillingAccess) {
    return (
      <Box sx={{ minHeight: '100%', backgroundColor: 'background.default' }}>
        <Container maxWidth="xl" sx={{ py: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Alert severity="warning">
              You don&apos;t have access to the billing feature. Please contact your administrator.
            </Alert>
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100%', backgroundColor: 'background.default' }}>
      <BillingLanding />
    </Box>
  );
};
